import { Delete, Edit, ElectricBolt, Kitchen } from "@mui/icons-material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PlumbingIcon from "@mui/icons-material/Plumbing";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  Avatar,
  Box,
  Button,
  Chip,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import JobDetailsDialog from "../../app/booking/JobDetailsDialog";
import LocationMapDialog from "../../app/booking/LocationMapDialog";
import { APP_ICONS } from "../../assets";
import SweetAlertConfirm from "../sweetAlert";
import TextInput from "../textInput";

const tableStyle = {
  "&.MuiTableContainer-root .MuiTableHead-root": {
    backgroundColor: "secondary.light",
  },
  "&.MuiTableContainer-root .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root":
    {
      fontSize: "1rem",
      color: "customColor.scorpion",
      fontWeight: 600,
    },
  "&.MuiTableContainer-root .MuiTableBody-root .MuiTableRow-root .MuiTableCell-root":
    {
      fontSize: "1rem",
      color: "customColor.tundora",
      padding: "10px 16px",
    },

  "& .chip-status": {
    borderRadius: "8px",
    width: 70,
  },
  "& .chip-status .MuiChip-label": {
    paddingLeft: "0px",
    paddingRight: "0px",
  },
  "& .withdrawn-status": {
    borderRadius: "8px",
    width: 80,
  },
  "& .withdrawn-status .MuiChip-label": {
    paddingLeft: "0px",
    paddingRight: "0px",
  },
  "& .stripe-tab": {
    borderRadius: "8px",
    width: 60,
    height: 30,
    fontWeight: 800,
    color: "#635bff",
    backgroundColor: "customColor.moonRaker",
  },
  "& .stripe-tab .MuiChip-label": {
    paddingLeft: "0px",
    paddingRight: "0px",
  },
  "& .action-button": {
    padding: "0px",
    height: 40,
    width: 40,
  },
};

export default function DynamicTable({
  minWidth,
  tableHeader,
  tableData,
  displayRows,
  showPagination,
  showUserMenu,
  showVendorMenu,
  showWithDrawnMenu,
  showCommissionMenu,
  showRequestMenu,
  onEdit,
  onDelete,
  handleEdit,
  handleDelete,
  handleChangeStatus,
  recommendedAmmount,
  handleChangeRecommendedAmount,
  onEyeClick,
}) {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [anchorEl, setAnchorEl] = useState(null);
  const [statuses, setStatuses] = useState({});
  const [selectedJob, setSelectedJob] = useState(null);
  const [isJobDetailsOpen, setIsJobDetailsOpen] = useState(false);
  const [isLocationOpen, setIsLocationOpen] = useState(false);

  const handleToggle = (rowId) => {
    setStatuses((prevStatuses) => {
      const newStatuses = {};
      // Set all statuses to false except the toggled one
      Object.keys(prevStatuses).forEach((id) => {
        newStatuses[id] = id === rowId ? !prevStatuses[id] : false;
      });
      return newStatuses;
    });
  };
  const handleOpenMenu = (event, index) => {
    setAnchorEl({ el: event.currentTarget, index });
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const withDrawnStatusColor = (status) => {
    if (status === "Pending")
      return {
        bgColor: "customColor.tequila",
        color: "customColor.tahitiGold",
      };
    if (status === "Approved")
      return {
        bgColor: "customColor.blueRomance",
        color: "customColor.malachite",
      };
    if (status === "Rejected")
      return {
        bgColor: "customColor.palePink",
        color: "customColor.darkRed",
      };
  };

  const sponsoredStatusColor = (status) => {
    if (status === "Pending")
      return {
        bgColor: "customColor.tequila",
        color: "customColor.tahitiGold",
      };
    if (status === "Yes")
      return {
        bgColor: "customColor.blueRomance",
        color: "customColor.malachite",
      };
    if (status === "No")
      return {
        bgColor: "customColor.palePink",
        color: "customColor.darkRed",
      };
  };

  const userStatusColor = (status) => {
    if (status === "True")
      return {
        color: "customColor.malachite",
        bgColor: "customColor.blueRomance",
      };
    if (status === "False")
      return {
        color: "customColor.gray",
        bgColor: "customColor.alto",
      };
  };

  const handleViewJob = (row) => {
    setSelectedJob(row);
    setIsJobDetailsOpen(true);
  };

  const handleViewLocation = (row) => {
    setSelectedJob(row);
    setIsLocationOpen(true);
  };

  return (
    <>
      <TableContainer sx={tableStyle}>
        <Table
        // sx={{
        //   minWidth: minWidth ? minWidth : "900px",
        // }}
        >
          <TableHead sx={{ backgroundColor: "#fff" }}>
            <TableRow>
              {tableHeader?.map((header) => (
                <TableCell key={header} sx={{ width: 100 }}>
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {(rowsPerPage > 0
              ? tableData?.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
              : tableData
            )?.map((row, index) => {
              console.log(row, "rowwwwwwww");

              const userStatus = row.status;
              const withdrawmStatus = row.status;
              const sponsoredStatus = row.status;

              const start = new Date(row.startDate);
              const end = new Date(row.endDate);

              start.setHours(0, 0, 0, 0);
              end.setHours(0, 0, 0, 0);

              let totalDays =
                Math.floor((end - start) / (1000 * 60 * 60 * 24)) + 1;

              if (totalDays <= 0) totalDays = 1;

              const parseTime = (timeStr) => {
                if (!timeStr || typeof timeStr !== "string") return null;

                const parts = timeStr.trim().split(" ");
                if (parts.length !== 2) return null;

                const [time, modifier] = parts;
                const timeParts = time.split(":");

                if (timeParts.length !== 2) return null;

                let hours = Number(timeParts[0]);
                let minutes = Number(timeParts[1]);

                if (isNaN(hours) || isNaN(minutes)) return null;

                if (modifier === "PM" && hours !== 12) hours += 12;
                if (modifier === "AM" && hours === 12) hours = 0;

                return hours * 60 + minutes;
              };

              const startMinutes = parseTime(row.startTime);
              const endMinutes = parseTime(row.endTime);

              const isNightShift =
                startMinutes !== null &&
                endMinutes !== null &&
                startMinutes >= 1200 &&
                endMinutes <= 180 &&
                totalDays === 2;

              if (isNightShift) {
                totalDays = 1;
              }

              console.log(totalDays, "TOTAL DAYS");

              return (
                <TableRow key={index}>
                  {displayRows.map((val) => (
                    <React.Fragment key={val}>
                      {val === "_id" ? (
                        <TableCell>{index + 1}</TableCell>
                      ) : val === "created_at" ? (
                        <TableCell>
                          {moment(row.createdAt).format("MM/DD/YYYY")}
                        </TableCell>
                      ) : val === "jobId" ? (
                        <TableCell>{row?.jobId}</TableCell>
                      ) : val === "earnings" ? (
                        <TableCell>CA$ {row.amount}</TableCell>
                      ) : val === "totalHours" ? (
                        <TableCell> {row.totalHours} </TableCell>
                      ) : val === "user_id" ? (
                        <TableCell>#{row._id}</TableCell>
                      ) : val === "user_data" ? (
                        <TableCell>
                          <Stack
                            direction={"row"}
                            alignItems={"center"}
                            gap={1}
                          >
                            <Avatar
                              src={row.image}
                              sx={{
                                height: 45,
                                width: 45,
                              }}
                            />
                            <Stack>
                              <Typography
                                fontWeight={500}
                                lineHeight={"normal"}
                              >
                                {row.firstname}
                              </Typography>
                              <Typography lineHeight={"normal"}>
                                {row.email}
                              </Typography>
                            </Stack>
                          </Stack>
                        </TableCell>
                      ) : val === "vendor_status" ? (
                        <TableCell>
                          <Chip
                            label={userStatus === true ? "Active" : "Inactive"}
                            className="chip-status"
                            sx={{
                              color: userStatusColor(userStatus)?.color,
                              backgroundColor:
                                userStatusColor(userStatus)?.bgColor,
                            }}
                          />
                        </TableCell>
                      ) : val === "phone" ? (
                        <TableCell>{row.contact || "N/A"}</TableCell>
                      ) : val === "startDate" ? (
                        <TableCell>
                          {moment(row.startDate).format("MM/DD/YYYY")}
                        </TableCell>
                      ) : val === "endDate" ? (
                        <TableCell>
                          {moment(row.endDate).format("MM/DD/YYYY")}
                        </TableCell>
                      ) : val === "startTime" ? (
                        <TableCell>{row.startTime}</TableCell>
                      ) : val === "endTime" ? (
                        <TableCell>{row.endTime}</TableCell>
                      ) : val === "duration" ? (
                        <TableCell>{totalDays} days</TableCell>
                      ) : val === "your_recommended_amount" ? (
                        <TableCell width={1000}>
                          <Stack
                            direction={"row"}
                            gap={2}
                            alignItems={"center"}
                          >
                            <TextInput
                              placeholder={"Recommended Amount"}
                              sx={{ width: "70%", padding: "0px 0" }}
                              value={recommendedAmmount[row?._id] || ""}
                              onChange={(e) =>
                                handleChangeRecommendedAmount(
                                  e.target.value,
                                  row?._id
                                )
                              }
                            />
                            {/* <Button
                              variant="contained"
                              size="small"
                              sx={{
                                fontSize: "12px",
                                textTransform: "none",
                                width: "30%",
                              }}
                            >
                              Update
                            </Button> */}
                          </Stack>
                        </TableCell>
                      ) : val === "jobs_details" ? (
                        <TableCell>
                          <Stack spacing={1}>
                            <Button
                              startIcon={<VisibilityIcon />}
                              variant="contained"
                              size="small"
                              sx={{
                                fontSize: "12px",
                                textTransform: "none",
                              }}
                              onClick={() => handleViewJob(row)}
                            >
                              Details
                            </Button>
                          </Stack>
                        </TableCell>
                      ) : val === "location" ? (
                        <TableCell>
                          <Stack spacing={1}>
                            <Button
                              startIcon={
                                <LocationOnIcon
                                  sx={{ fontSize: "12px", mr: "1px" }}
                                />
                              }
                              sx={{
                                fontSize: "12px",
                                textTransform: "none",
                              }}
                              variant="contained"
                              size="small"
                              color="secondary"
                              onClick={() => handleViewLocation(row)}
                            >
                              Map
                            </Button>
                          </Stack>
                        </TableCell>
                      ) : val === "eye" ? (
                        <TableCell>
                          <IconButton onClick={() => onEyeClick(row)}>
                            <VisibilityIcon />
                          </IconButton>
                        </TableCell>
                      ) : val === "price" ? (
                        <TableCell>
                          <Typography>${row?.price}</Typography>
                        </TableCell>
                      ) : val === "totalAmount" ? (
                        <TableCell>
                          <Typography>${row?.totalAmount}</Typography>
                        </TableCell>
                      ) : val === "hourlyRate" ? (
                        <TableCell>
                          <Typography>${row?.hourlyRate}</Typography>
                        </TableCell>
                      ) : val === "withDrawn_amount" ? (
                        <TableCell>${row.amount}</TableCell>
                      ) : val === "withDrawn_status" ? (
                        <TableCell>
                          <Chip
                            label={withdrawmStatus}
                            className="withdrawn-status"
                            sx={{
                              color: withDrawnStatusColor(row.status).color,
                              backgroundColor: withDrawnStatusColor(row.status)
                                .bgColor,
                            }}
                          />
                        </TableCell>
                      ) : val === "sponsored_status" ? (
                        <TableCell>
                          <Chip
                            label={sponsoredStatus}
                            className="withdrawn-status"
                            sx={{
                              color: sponsoredStatusColor(row.status)?.color,
                              backgroundColor: sponsoredStatusColor(row.status)
                                ?.bgColor,
                            }}
                          />
                        </TableCell>
                      ) : val === "id" ? (
                        <TableCell>{row.id}</TableCell>
                      ) : val === "question" ? (
                        <TableCell>{row.question}</TableCell>
                      ) : val === "answer" ? (
                        <TableCell>{row.answer}</TableCell>
                      ) : val === "actions_btn" ? (
                        <TableCell>
                          <Box display={"flex"} flexDirection={"row"} gap={2}>
                            <Button
                              sx={{
                                padding: "5px",
                                width: "30px",
                                height: "30px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "5px",
                                backgroundColor: "#800000",
                                color: "#fff",
                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                transition:
                                  "background-color 0.3s, transform 0.2s",
                                "&:hover": {
                                  backgroundColor: "#6e0202",
                                  transform: "scale(1.05)",
                                },
                                "&:active": {
                                  backgroundColor: "#6e0202",
                                  transform: "scale(0.95)",
                                },
                              }}
                              size="small"
                              onClick={() => handleEdit(row)}
                            >
                              <Edit fontSize="small" />
                            </Button>
                            <Button
                              sx={{
                                padding: "5px",
                                width: "30px",
                                height: "30px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "5px",
                                backgroundColor: "#ffe6e6",
                                color: "#ff4d4d",
                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                transition:
                                  "background-color 0.3s, transform 0.2s",
                                "&:hover": {
                                  backgroundColor: "#ffcccc",
                                  transform: "scale(1.05)",
                                },
                                "&:active": {
                                  backgroundColor: "#ffb3b3",
                                  transform: "scale(0.95)",
                                },
                              }}
                              size="small"
                              onClick={() => {
                                SweetAlertConfirm(
                                  "Are you sure?",
                                  "You won't be able to revert this!",
                                  () => handleDelete(row)
                                );
                              }}
                            >
                              <Delete fontSize="small" />
                            </Button>
                          </Box>
                        </TableCell>
                      ) : val === "actions_button" ? (
                        <TableCell>
                          <Box display={"flex"} flexDirection={"row"} gap={2}>
                            <Button
                              sx={{
                                padding: "5px",
                                width: "30px",
                                height: "30px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "5px",
                                backgroundColor: "#800000",
                                color: "#ffff",
                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                transition:
                                  "background-color 0.3s, transform 0.2s",
                                "&:hover": {
                                  backgroundColor: "#6e0202",
                                  transform: "scale(1.05)",
                                },
                                "&:active": {
                                  backgroundColor: "#6e0202",
                                  transform: "scale(0.95)",
                                },
                              }}
                              size="small"
                              onClick={() => onEdit(row)}
                            >
                              <Edit fontSize="small" />
                            </Button>
                            <Button
                              sx={{
                                padding: "5px",
                                width: "30px",
                                height: "30px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "5px",
                                backgroundColor: "#ffe6e6",
                                color: "#ff4d4d",
                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                transition:
                                  "background-color 0.3s, transform 0.2s",
                                "&:hover": {
                                  backgroundColor: "#ffcccc",
                                  transform: "scale(1.05)",
                                },
                                "&:active": {
                                  backgroundColor: "#ffb3b3",
                                  transform: "scale(0.95)",
                                },
                              }}
                              size="small"
                              onClick={() => {
                                SweetAlertConfirm(
                                  "Are you sure?",
                                  "You won't be able to revert this!",
                                  () => onDelete(row)
                                );
                              }}
                            >
                              <Delete fontSize="small" />
                            </Button>
                          </Box>
                        </TableCell>
                      ) : val === "profile_status" ? (
                        <TableCell>
                          <Switch
                            checked={row?.status}
                            onChange={(e) =>
                              handleChangeStatus(e.target.checked, row, index)
                            }
                            color="primary"
                            sx={{
                              "&.Mui-checked": {
                                bgcolor: "customColor.malachite",
                              },
                              "&.Mui-checked:hover": {
                                bgcolor: "customColor.malachite",
                              },
                              "&.MuiSwitch-track": {
                                bgcolor: "customColor.tundora",
                              },
                              "&:hover": {
                                bgcolor: "rgba(0, 0, 0, 0.08)",
                              },
                            }}
                          />
                        </TableCell>
                      ) : val === "isActive" ? (
                        <TableCell>
                          <Switch
                            checked={!!row?.isActive}
                            onChange={(e) =>
                              handleChangeStatus
                                ? handleChangeStatus(
                                    e.target.checked,
                                    row,
                                    index
                                  )
                                : null
                            }
                            color="primary"
                            sx={{
                              "&.Mui-checked": {
                                bgcolor: "customColor.malachite",
                              },
                              "&.Mui-checked:hover": {
                                bgcolor: "customColor.malachite",
                              },
                              "&.MuiSwitch-track": {
                                bgcolor: "customColor.tundora",
                              },
                              "&:hover": {
                                bgcolor: "rgba(0, 0, 0, 0.08)",
                              },
                            }}
                          />
                        </TableCell>
                      ) : val === "total_sales" ? (
                        <TableCell>${row.totalSales}</TableCell>
                      ) : val === "total_commission" ? (
                        <TableCell sx={{ textAlign: "center" }}>
                          ${row.commission}
                        </TableCell>
                      ) : val === "profession" ? (
                        <TableCell>
                          <Box display="flex" alignItems="center">
                            {row.profession === "Chef" ? (
                              <IconButton style={{ marginRight: "8px" }}>
                                <Kitchen />
                              </IconButton>
                            ) : row.profession === "Electrician" ? (
                              <IconButton style={{ marginRight: "8px" }}>
                                <ElectricBolt />
                              </IconButton>
                            ) : row.profession === "Plumber" ? (
                              <IconButton style={{ marginRight: "8px" }}>
                                <PlumbingIcon />
                              </IconButton>
                            ) : null}

                            <Typography variant="body2">
                              {row.profession}
                            </Typography>
                          </Box>
                        </TableCell>
                      ) : val === "charge_per_hour" ? (
                        <TableCell>${row.charge_per_hour}</TableCell>
                      ) : val === "booking_time" ? (
                        <TableCell>
                          {`From ${row.booking_time.start} to ${row.booking_time.end}`}
                        </TableCell>
                      ) : val === "booking_date" ? (
                        <TableCell>
                          {new Date(row.booking_date).toLocaleDateString()}
                        </TableCell>
                      ) : val === "title" ? (
                        <TableCell>{row?.title}</TableCell>
                      ) : val === "body" ? (
                        <TableCell>{row?.body}</TableCell>
                      ) : val === "status_booking" ? (
                        <TableCell
                          style={{
                            color:
                              row.status === "completed"
                                ? "green"
                                : row.status === "cancelled"
                                ? "red"
                                : "orange",
                          }}
                        >
                          {row.status}
                        </TableCell>
                      ) : val === "catagory_name" ? (
                        <TableCell>
                          <Stack
                            direction={"row"}
                            alignItems={"center"}
                            gap={1}
                          >
                            <Avatar
                              src={row.image}
                              sx={{
                                height: 45,
                                width: 45,
                              }}
                            />
                            <Stack>
                              <Typography
                                fontWeight={500}
                                lineHeight={"normal"}
                              >
                                {row.name}
                              </Typography>
                            </Stack>
                          </Stack>
                        </TableCell>
                      ) : val === "job_title" ? (
                        <TableCell>{row.name}</TableCell>
                      ) : val === "payment_data" ? (
                        <TableCell>
                          <Stack
                            direction={"row"}
                            alignItems={"center"}
                            gap={1}
                          >
                            <Chip label="stripe" className="stripe-tab" />
                            <Stack>
                              <Typography
                                fontWeight={500}
                                lineHeight={"normal"}
                              >
                                {row.name}
                              </Typography>
                              <Typography lineHeight={"normal"}>
                                {row.accountNo}
                              </Typography>
                            </Stack>
                          </Stack>
                        </TableCell>
                      ) : val === "job_type" ? (
                        <TableCell>{row.jobType}</TableCell>
                      ) : val === "firstname" ? (
                        <TableCell>{row.firstname}</TableCell>
                      ) : val === "actions" ? (
                        <TableCell>
                          <IconButton
                            className="action-button"
                            onClick={(event) => handleOpenMenu(event, index)}
                          >
                            <img src={APP_ICONS.ellipsisIcon} width={20} />
                          </IconButton>
                          {anchorEl?.index === index && (
                            <Menu
                              anchorEl={anchorEl.el}
                              open={Boolean(anchorEl)}
                              onClose={handleCloseMenu}
                              anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "center",
                              }}
                              transformOrigin={{
                                vertical: "top",
                                horizontal: "center",
                              }}
                              sx={{
                                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                              }}
                              PaperProps={{
                                sx: {
                                  width: "100px",
                                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                                  "&.MuiMenuItem-root": {
                                    textAlign: "center",
                                  },
                                },
                              }}
                            >
                              {showUserMenu && (
                                <>
                                  <MenuItem
                                    onClick={() => {
                                      handleCloseMenu();
                                      navigate("/user-profile");
                                    }}
                                  >
                                    View Profile
                                  </MenuItem>
                                  <MenuItem onClick={handleCloseMenu}>
                                    Active
                                  </MenuItem>
                                  <MenuItem onClick={handleCloseMenu}>
                                    Inactive
                                  </MenuItem>
                                </>
                              )}
                              {showVendorMenu && (
                                <>
                                  <MenuItem
                                    onClick={() => {
                                      handleCloseMenu();
                                      navigate("/vendor-profile");
                                    }}
                                  >
                                    View Profile
                                  </MenuItem>
                                  <MenuItem onClick={handleCloseMenu}>
                                    Active
                                  </MenuItem>
                                  <MenuItem onClick={handleCloseMenu}>
                                    Inactive
                                  </MenuItem>
                                </>
                              )}
                              {showWithDrawnMenu && (
                                <>
                                  <MenuItem
                                    onClick={() => {
                                      handleCloseMenu();
                                      navigate("/vendor-profile");
                                    }}
                                  >
                                    View
                                  </MenuItem>
                                  <MenuItem onClick={handleCloseMenu}>
                                    Approved
                                  </MenuItem>
                                  <MenuItem onClick={handleCloseMenu}>
                                    Reject
                                  </MenuItem>
                                </>
                              )}
                              {showCommissionMenu && (
                                <>
                                  <MenuItem
                                    onClick={() => {
                                      handleCloseMenu();
                                      navigate("/vendor-profile");
                                    }}
                                  >
                                    View
                                  </MenuItem>
                                  <MenuItem
                                    onClick={() => {
                                      handleCloseMenu();
                                      navigate("/vendor-profile");
                                    }}
                                  >
                                    Edit
                                  </MenuItem>
                                </>
                              )}
                              {showRequestMenu && (
                                <>
                                  <MenuItem
                                    onClick={() => {
                                      handleCloseMenu();
                                    }}
                                  >
                                    Approve
                                  </MenuItem>
                                  <MenuItem
                                    onClick={() => {
                                      handleCloseMenu();
                                    }}
                                  >
                                    Reject
                                  </MenuItem>
                                </>
                              )}
                            </Menu>
                          )}
                        </TableCell>
                      ) : val === "jobStatus" ? (
                        <TableCell>
                          <Chip
                            label={row.jobStatus}
                            className="withdrawn-status"
                            sx={{
                              color: "#fff",
                              backgroundColor:
                                row.jobStatus === "Completed"
                                  ? "green"
                                  : row.jobStatus === "Cancelled"
                                  ? "red"
                                  : "orange",
                            }}
                          />
                        </TableCell>
                      ) : val === "customer_details" ? (
                        <TableCell>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={2}
                          >
                            <Avatar src={row.createdBy?.image} />
                            <Box>
                              <Typography variant="body1">
                                {row.createdBy?.firstname}{" "}
                                {row.createdBy?.lastname}
                              </Typography>
                              <Typography variant="body2" color="textSecondary">
                                {row.createdBy?.email}
                              </Typography>
                            </Box>
                          </Stack>
                        </TableCell>
                      ) : val === "provider_details" ? (
                        <TableCell>
                          <Stack
                            direction={"row"}
                            alignItems={"center"}
                            gap={1}
                          >
                            <Avatar
                              src={row.providerDetails?.image}
                              sx={{
                                height: 45,
                                width: 45,
                              }}
                            />
                            <Stack>
                              <Typography
                                fontWeight={500}
                                lineHeight={"normal"}
                              >
                                {row.providerDetails?.firstname}
                              </Typography>
                            </Stack>
                          </Stack>
                        </TableCell>
                      ) : val === "job_time" ? (
                        <TableCell>
                          {`${new Date(
                            row.jobStartTime
                          ).toLocaleTimeString()} - ${new Date(
                            row.jobEndTime
                          ).toLocaleTimeString()}`}
                        </TableCell>
                      ) : (
                        <TableCell>
                          <Typography lineHeight="normal" fontSize={"1rem"}>
                            {row[val]}
                          </Typography>
                        </TableCell>
                      )}
                    </React.Fragment>
                  ))}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
        {showPagination && (
          <TablePagination
            rowsPerPageOptions={[5, 10, 20, 30, 40]}
            component="div"
            count={tableData?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        )}
      </TableContainer>

      <JobDetailsDialog
        open={isJobDetailsOpen}
        onClose={() => setIsJobDetailsOpen(false)}
        jobData={selectedJob}
      />

      <LocationMapDialog
        open={isLocationOpen}
        onClose={() => setIsLocationOpen(false)}
        jobData={selectedJob}
      />
    </>
  );
}
